import request from '@/utils/request'

/**
 * 查询DEMO列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function getDemoList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/demo.queryDemoConfig',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存DEMO配置
 * @param {Object} data 保存数据
 * @returns {Promise} Promise对象
 */
export function saveDemoConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/demo.saveDemoConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}